import { Component, Inject, Type } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { BautagebuchDialogData } from '../models/bautagebuch-dialog-data.model';
import {
  BautagebuchWorkspaceRegistration,
  BautagebuchWorkspaceRegistryService
} from '../services/bautagebuch-workspace-registry.service';

@Component({
  standalone: false,
  selector: 'app-bautagebuch-dialog-shell',
  templateUrl: './bautagebuch-dialog-shell.component.html',
  styleUrls: ['./bautagebuch-dialog-shell.component.scss']
})
export class BautagebuchDialogShellComponent {
  readonly registration: BautagebuchWorkspaceRegistration;
  readonly workspaceComponent: Type<unknown>;

  constructor(
    private readonly registry: BautagebuchWorkspaceRegistryService,
    @Inject(MAT_DIALOG_DATA) public readonly data: BautagebuchDialogData
  ) {
    this.registration = this.registry.resolve(data);
    this.workspaceComponent = this.registration.component;
  }
}
